import { render, staticRenderFns } from "./CreateGroupModal.vue?vue&type=template&id=7acb434e&"
import script from "./CreateGroupModal.vue?vue&type=script&lang=ts&"
export * from "./CreateGroupModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports